import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门话题', href: '#topics' },
  { label: '精选专题', href: '#cards' },
  { label: '焦点专题', href: '#carousel' },
  { label: '秒开抢先看', href: '#media' },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header navItems={navItems} />

      <main>
        <Hero />
        <MediaSection />
        <FaqSection />
        <TopicsSection />
        <CommentsSection />
        <UpdatesSection />
        <AppSection />
        <AboutSection />
        <CardsSection />
        <ContactSection />
        <CarouselSection />
        <IndexSection />
        <FeaturesSection />
        <RankingSection />
      </main>

      <Footer />
    </div>
  );
}